import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import { connect } from 'react-redux'
import { Dropdown, Modal, Image, Row, Col } from 'react-bootstrap'
import classnames from 'classnames'
import { toastr } from 'react-redux-toastr'
import Toggle from 'react-toggle'
import _ from 'lodash'
import FileSaver from 'file-saver'
import { useTranslation } from 'react-i18next'
import { RiAlertLine } from 'react-icons/ri'

import ModalDeviceReplace from '../modals/ModalDeviceReplace'
import ModalProvisionDevice from '../modals/ModalProvisionDevice'
import ConfigModal from '../modals/ConfigModal'
import VehicleDeleteModal from '../modals/VehicleDeleteModal'
import AddInstallReportModal from '../modals/AddInstallReportModal'
import CameraEnableToggle from '../../../pages/vehicles/CameraEnableToggle'
import ModalChangeConfBatch from '../modals/ModalChangeConfBatch'
import DeviceArchiveHistory from '../../../pages/vehicles/DeviceArchiveHistory'
import ModalInstallReport from '../modals/ModalInstallReport'
import AdasCalibrationSettings from '../../../pages/vehicles/AdasCalibrationSettings'
import GreyHeader from '../../dump/menuComponents/GreyHeader'
import IconTooltip from '../../dump/menuComponents/IconTooltip'
import CustomButton from '../../CustomButton'
import ModalDeviceOfflineDisabled from '../../../pages/vehicles/ModalDeviceOfflineDisabled'
import CustomOverlayTrigger from '../../CustomOverlayTrigger'

import { dvType, isInternalUser, isInternalUserWithPartner, constants } from '../../helpers/constants'
import { vehicleIcons, detectDeviceStatus } from '../../helpers/helperVehicle'
import { formatTimestamp, formatOnlineStatusLocal } from '../../helpers/tablesFuncHelpers'
import { isCustomUserPermissions } from '../../helpers/helperUsers'
import { getDeviceById, updateDevice } from '../../../action/DeviceActions'
import { getCompanyGroups } from '../../../action/GroupsActions'
import { getCompanyGeotabData, setWebfleetCard } from '../../../action/GeotabActions'
import { getConfigFile } from '../../../action/FleetAdminActions'
import { apiCallGet } from '../../../action/RouterActions'
import { getCompanyById } from '../../../action/CompaniesActions'

import '../../dump/menuComponents/menuComponents.sass'
import '../../dump/menuComponents/ManageVehicles.sass'
import 'react-dual-listbox/lib/react-dual-listbox.css'

const EditAssetContainer = (props) => {
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'manageVehiclesPage.editAssetContainer' });
	const { user, company, location, params, toggleLoader } = props;
	const userRole = user.roles[0];
	const userPermissions = user.permissions;

	const [state, setState] = useState({
		deviceId: (!_.isEmpty(location.state) && location.state.id) || (!_.isEmpty(params) && params.id) || 'undefined',
		initialData: null,
		companyData: null,
		data: {},
		errMessage: {
			errvehicle_name: '',
			errvehicle_icon: '',
			errgroups: '',
			errdata_limit: '',
		},
		confirmCanbus: false,
		provisionType: null,
		showModalProvisionDevice: false,
		showConfigModal: false,
		showDeleteModal: false,
		showAddInstallReportModal: false,
		showModalInstallReport: false,
		showModalDeviceArchiveHistory: false,
	})
	const [showModalApplyProfile, setShowModalApplyProfile] = useState(false)
	const [showConfirmCanbusModal, setshowConfirmCanbusModal] = useState(false)
	const [showModalDeviceReplace, setShowModalDeviceReplace] = useState(false)
	const [groupsList, setGroupsList] = useState([])
	// const [geotabCredentials, setGeotabCredentials] = useState(null)
	// const [webfleetCredentials, setWebfleetCredentials] = useState(null)
	// const [ituranCredentials, setIturanCredentials] = useState(null)
	const [devicesOfflineDisabled, setDevicesOfflineDisabled] = useState('')
	const [externalCredentials, setExternalCredentials] = useState(null) // one company has to have an integration/pairing just with single 3rd party service
	const [tabKey, setTabKey] = useState(1);

	const isDV6 = dvType(state.data) === 'dv6';
	const isDV4 = dvType(state.data) === 'dv4';
	const isDV7 = dvType(state.data) === 'dv7';

	const isProd = location.hostname === 'fleet.roscolive.com';
	const DV7access = (!isProd && !['S3 buckets partner'].includes(company.partner)) || (isProd && ['DV7 Rosco Testing'].includes(company.partner));

	useEffect(() => {
		getDevice();
	}, [])

	useEffect(() => {
		if (state.data.company_name || state.data.partner_name) {
			getGroupsList()
			if (state.data.geotab.serial_number || state.companyData.geotab_database) {
				getCompanyGeotabCredentials()
			}
			else if (state.data.external_srv.type === 'webfleet' || state.companyData.external_srv_type === 'webfleet') {
				getCompanyWebfleetCredentials()
			}
			else if (state.data.external_srv.type === 'ituran' || state.companyData.external_srv_type === 'ituran') {
				getCompanyIturanCredentials()
			}
		}
	}, [state.data.device_id])

	const getDevice = () => {
		// if (location) {
		// const deviceId = (!_.isEmpty(location.state) && location.state.id) || (!_.isEmpty(params) && params.id)
		toggleLoader(true);
		const attributes = {
			deviceId: state.deviceId,
			userRole,
			geotab: true,
			modem: true,
			includeData: 'replace,remove,channel_status,storage_wear',
			externalSrv: 'any',
		}
		getDeviceById(attributes)
			.then(res => {
				console.log('EditAssetContainer getDeviceById res: ', res)
				const deviceData = res.data.response.device
				deviceData.status = detectDeviceStatus(deviceData)

				// TODO: no sense anymore pass to this component the company data from other pages or components
				getCompanyById(userRole, deviceData.company_id)
					.then(resCompany => {
						toggleLoader(false)
						const companyData = resCompany.data.response.company
						// setState({
						// 	...state,
						// 	data: { ...state.data, ...deviceData },
						// 	initialData: deviceData,
						// 	companyData
						// })
						const data = _.cloneDeep(deviceData);
						if (deviceData.pending_config && _.has(deviceData.pending_config, 'ignition_switch_only')) {
							data.ignition_switch_only = deviceData.pending_config.ignition_switch_only
						}
						setState((prevState) => ({
							...prevState,
							data: { ...state.data, ...data },
							initialData: deviceData,
							companyData
						}))
					})
					.catch((error) => {
						toggleLoader(false);
						console.log('EditAssetContainer getDeviceById error: ', error.response, error)
						toastr.error('Unable to retrieve company settings. Please try again later.')
					})
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('EditAssetContainer getDeviceById error: ', error.response, error)
				toastr.error(t('unableRetrieveDeviceSettings'))
			})
	}

	const getGroupsList = () => {
		toggleLoader(true)
		const company = {
			name: state.data.company_name,
			partner: state.data.partner_name,
		}
		getCompanyGroups(userRole, company)
			.then(res => {
				toggleLoader(false)
				const groups = res.data.response.groups.filter(item => item.toLowerCase() !== 'installed devices');
				setGroupsList(groups);
			})
			.catch(error => {
				toggleLoader(false)
				console.log('!getCompanyGroups error', error.response);
				toastr.error(t('issueGettingCompanyGroups'))
			})
	}

	const getCompanyGeotabCredentials = () => {
		// const { location } = props;
		// if (location) {
		getCompanyGeotabData({
			// partner_name: location.state.company.partner,
			// company_name: location.state.company.name,
			company_name: state.data.company_name,
			partner_name: state.data.partner_name,
			get_p: true,
		})
			.then(async (res) => {
				// setState({ ...state, geotab_company: await res.data.response })
				// setGeotabCredentials(res.data.response)
				setExternalCredentials({ ...res.data.response, type: 'geotab' })
			})
			.catch((error) => {
				// NO GEOTAB COMPANY
				//* if it returns 'company does not exists' then this company does not belong to any geotab company
				console.log('!getCompanyGeotabData error: ', error.response)
				toastr.error(t('issueGettingGeotabCredentiqals'))
			})
		// }
	}

	const getCompanyWebfleetCredentials = () => {
		apiCallGet('/external_service/webfleet/account', { company_id: state.data.company_id })
			.then(res => {
				// setState({ ...state, webfleetCredentials: res.data.response })
				// setWebfleetCredentials(res.data.response)
				setExternalCredentials(res.data.response)
			})
			.catch((error) => {
				// NO WEBFLEET COMPANY
				//* if it returns 'company does not exists' then this company does not belong to any webfleet company
				console.log('!getCompanyWebfleetCredentials error: ', error.response)
				toastr.error('There was an issue getting company webfleet credentiqals. Please try again later.')
			})
	}

	const getCompanyIturanCredentials = () => {
		apiCallGet('/external_service/ituran/account', { company_id: state.data.company_id })
			.then(res => {
				// setState({ ...state, webfleetCredentials: res.data.response })
				// setIturanCredentials(res.data.response)
				setExternalCredentials(res.data.response)
			})
			.catch((error) => {
				// NO ITURAN COMPANY
				//* if it returns 'company does not exists' then this company does not belong to any webfleet company
				console.log('!getCompanyIturanCredentials error: ', error.response)
				toastr.error(t('issueGettingWebfleetCredentiqals'))
			})
	}

	const goBack = () => {
		if (location && location.state && location.state.type) {
			switch (location.state.type) {
				case 'reports':
					browserHistory.push({ pathname: '/reports' });
					break;
				case 'vehicle_sidebar':
					browserHistory.push({ pathname: '/', state: { id: location.state.id, company: location.state.company, type: 'return_to_map' } });
					break;
				case '/event':
				case '/managedrivers':
					browserHistory.push({ pathname: location.state.type })
					break;
				default:
					browserHistory.push('/managevehicles')
					break;
			}
		}
		else {
			browserHistory.push('/managevehicles')
		}
	}

	const saveVehicle = (confirmCanbus) => {
		const { data, initialData } = state;
		if (data.pending_config && _.has(data.pending_config, 'ignition_switch_only')) {
			initialData.ignition_switch_only = data.pending_config.ignition_switch_only
		}
		// const { company } = location.state;
		const company = {
			name: data.company_name,
			partner: data.partner_name,
		}
		const changedData = _.reduce(_.keys(data), (result, key) => {
			if (!Object.prototype.hasOwnProperty.call(initialData, key) || !_.isEqual(initialData[key], data[key])) {
				result[key] = data[key]
			}
			return result;
		}, {});
		if (_.isEmpty(changedData)) {
			toastr.warning('', t('vehicleNoChanges'))
			return
		}

		const error = checkForm(changedData)

		const newData = { ...state, data: changedData }
		if (!['system_admin', 'customer_service'].includes(userRole) && _.get(state, 'data.data_limit')) {
			// TODO: a separate function to define the data to be saved by user roles
			delete state.data.data_limit
		}

		if (!error) {
			if (data.canbus !== initialData.canbus && data.canbus !== "0" && !confirmCanbus) {
				setshowConfirmCanbusModal(true);
				return
			}
			else if (data.canbus === initialData.canbus) {
				delete newData.data.canbus;
			}
			toggleLoader(true);

			updateDevice(newData, userRole, company, (err, res) => {
				setTimeout(getDevice, 300)

				// Sends device config.txt to device
				if (err) {
					toggleLoader(false);
					console.log('!updateDevice sendForm error', err)

					let errDescription = i18n.t('errorMessage.errDescription');
					if (err.response.data.body) {
						errDescription = err.response.data.body
					}
					toastr.error(errDescription)
				} else {
					const params = {}
					if (data.vehicle_name !== initialData.vehicle_name) {
						params.IdInfo = { DvrName: data.vehicle_name }
					}
					if (data.cardreader !== initialData.cardreader) {
						const CardReader = { Enabled: data.cardreader }
						params.Peripherals = { CardReader }
					}
					if (newData.data.canbus) {
						const CanBus = { Type: newData.data.canbus * 1 }
						params.Peripherals = { CanBus }
					}
					// Adas updates
					if (data.adas_vehicle_hood_len !== initialData.adas_vehicle_hood_len) {
						if (params.Event && params.Event.Adas) {
							params.Event.Adas.VehicleHoodLength = data.adas_vehicle_hood_len * 1
						}
						else {
							const Adas = { VehicleHoodLength: data.adas_vehicle_hood_len * 1 }
							params.Event = { Adas }
						}
					}
					if (data.adas_camera_height !== initialData.adas_camera_height) {
						if (params.Event && params.Event.Adas) {
							params.Event.Adas.CameraHeight = data.adas_camera_height * 1
						}
						else {
							const Adas = { CameraHeight: data.adas_camera_height * 1 }
							params.Event = { Adas }
						}
					}
					if (data.adas_vehicle_width !== initialData.adas_vehicle_width) {
						if (params.Event && params.Event.Adas) {
							params.Event.Adas.VehicleWidth = data.adas_vehicle_width * 1
						}
						else {
							const Adas = { VehicleWidth: data.adas_vehicle_width * 1 }
							params.Event = { Adas }
						}
					}
					if (data.adas_camera_offset !== initialData.adas_camera_offset) {
						if (params.Event && params.Event.Adas) {
							params.Event.Adas.CameraOffset = data.adas_camera_offset * 1
						}
						else {
							const Adas = { CameraOffset: data.adas_camera_offset * 1 }
							params.Event = { Adas }
						}
					}

					toastr.success('', t('updatedVehicle'))
					toggleLoader(false)

					// FWSD-7925, Moved sending device config to the API side
					// if (!_.isEmpty(params)) {
					// 	sendDeviceConfiguration(JSON.stringify(params))
					// } else {
					// 	toggleLoader(false);
					// }

					// FWSD-5295 - Sends webfleet setExternalObjectData request to update Rosco Live webfleet card
					if (state.data.external_srv.type === 'webfleet' || state.companyData.external_srv_type === 'webfleet') sendWebfleetCard()
				}
			})
		}
	}

	const sendWebfleetCard = () => {
		const { data } = state;

		const params = {
			account: externalCredentials.account,
			username: externalCredentials.username,
			password: encodeURI(externalCredentials.password),
			access_hash: externalCredentials.access_hash,
			vehicle_name: data.vehicle_name,
			online: data.ads_online,
			webfleet_sn: data.serial_number,
		}
		setWebfleetCard(params)
			.then()
			.catch(error => {
				console.log('sendWebfleetCard error:', error.response, error)
				toastr.error(t('errWebfleetCardUpdating'))
			})
	}

	// const sendDeviceConfiguration = (paramsArg) => {
	// 	const { device_id } = state.data;

	// 	getConfigFile(userRole, device_id, true)
	// 		.then(res => {
	// 			let config = res.data.split('\n')
	// 			// console.log('config: ', config)
	// 			config = fillConfig(config, paramsArg)

	// 			// console.log('config1: ', config)
	// 			let result = ''
	// 			Object.keys(config).forEach((key) => {
	// 				if (config.hasOwnProperty(key)) {
	// 					result += `${key}=${((typeof config[key]) === 'string') ? `"${config[key]}"` : config[key]}\r\n`
	// 				}
	// 			})
	// 			// console.log('result: ', result)
	// 			const blob = new Blob([result], { type: 'text/plain;charset=utf-8' });
	// 			const file = new File([blob], 'config.txt', { type: 'text/plain;charset=utf-8' })

	// 			const params = {
	// 				userRole,
	// 				deviceId: device_id,
	// 				file,
	// 				restart: true,
	// 				profileName: 'Manual',
	// 			}
	// 			if (config['IdInfo.FleetProfile']) {
	// 				params.profileName = config['IdInfo.FleetProfile']
	// 				if (config['IdInfo.FleetProfileId'] != null) {
	// 					params.profileId = config['IdInfo.FleetProfileId']
	// 				}
	// 			}
	// 			else if (state.data.pending_config_status === 'pending' && state.data.pending_company_profile) {
	// 				// pending_company_profile is device_config.company_profile, pending_config_status is device_config.config_status
	// 				params.profileName = state.data.pending_company_profile
	// 				if (state.data.pending_profile_id != null) {
	// 					params.profileId = state.data.pending_profile_id
	// 				}
	// 			}
	// 			else if (state.data.uploaded_company_profile) {
	// 				params.profileName = state.data.uploaded_company_profile
	// 				if (state.data.profile_id != null) {
	// 					params.profileId = state.data.profile_id
	// 				}
	// 			}

	// 			pushConfigFile(params)
	// 				.then(res => {
	// 					toggleLoader(false);
	// 					toastr.success(t('sentConfigFile'))
	// 				})
	// 				.catch(error => {
	// 					toggleLoader(false);
	// 					console.log('!uploadConfig pushConfigFile error:', error.response, error)
	// 					toastr.error(t('unableSentConfigFile'))
	// 				})
	// 		})
	// 		.catch((error) => {
	// 			toggleLoader(false);
	// 			console.log('!getConfigFile error: ', error.response, error)
	// 			let errDescription = t('unableSentConfigFile')
	// 			if (error.response.data.response.error) {
	// 				errDescription = errDescription + ': ' + error.response.data.response.error
	// 			}
	// 			toastr.error(errDescription)
	// 		})
	// }

	const fillConfig = (config, profile) => {
		const res1 = {};
		const res2 = {}

		config.map((elem, index) => {
			const tmp = elem.split('=')
			const val = _.trim(tmp[1]).replace(/"/g, '')

			if (_.trim(tmp[0]) === '') {
				return false
			} if (val === '') {
				res1[_.trim(tmp[0])] = ''
			} else if (val === 'true') {
				res1[_.trim(tmp[0])] = true
			} else if (val === 'false') {
				res1[_.trim(tmp[0])] = false
			} else if (isNaN(val)) {
				res1[_.trim(tmp[0])] = val
			} else {
				res1[_.trim(tmp[0])] = val * 1
			}
		})

		profile = JSON.parse(profile)

		traverse(res2, profile)

		return { ...res1, ...res2 }
	}

	const traverse = (res, o, parent = '') => {
		let i;

		for (const k in o) {
			i = o[k]
			if (_.isArray(i)) {
				i.map((obj, index) => {
					if (parent) {
						if (obj.index) traverse(res, obj, `${parent}.${k}.${obj.index}`)
						else traverse(res, obj, `${parent}.${k}.${index}`)
					} else if (obj.index) traverse(res, obj, `${k}.${obj.index}`)
					else traverse(res, obj, `${k}.${index}`)
				})
			} else if (typeof i === 'object') {
				if (parent) traverse(res, i, `${parent}.${k}`)
				else traverse(res, i, k)
			} else {
				if (k == 'index') continue
				if (parent) {
					res[`${parent}.${k}`] = i
				} else {
					res[k] = i
				}
			}
		}
	}

	const checkForm = (data) => {
		let error = false;
		let errMessage = state.errMessage;

		Object.keys(data).forEach((i) => {
			if (data[i] !== null) {
				if (data[i] === '' || data[i].length === 0) {
					error = true
					let message = i === 'groups' ? 'group' : i.replaceAll('_', ' ');
					errMessage['err' + i] = `${t('errEnter')} ${message}`
				}
				else if (i === 'vehicle_name' && (data[i].toString().trim() === '' || !/^[a-zA-Z0-9 ]+$/.test(data[i].toString()))) {
					error = true;
					errMessage['err' + i] = t('errEnterValidName');
				}
				else if (i === 'vehicle_name' && data[i].length > 50) {
					error = true;
					errMessage['err' + i] = t('errNameMaxLength')
				}
				else if (errMessage['err' + i]) {
					errMessage['err' + i] = null
				}
			}
		})

		setState({ ...state, errMessage: errMessage })
		if (error) {
			toastr.error('', t('errWrongValue'))
		}
		return error
	}

	const changeVehicleIcon = (icon) => {
		setState({
			...state,
			data: { ...state.data, vehicle_icon: icon },
			iconDropdownOpen: false
		})
	}

	const onInputChange = (event, name = null) => {
		const { target } = event;
		const field = target.name || name;
		let value = target.type === 'checkbox' ? target.checked : target.value;

		switch (field) {
			case 'adas_units':
				value = value ? 'imperial' : 'metric'
				break;
			case 'disable_live_stream':
				value = !value;
				break;
			case 'ignition_switch_only':
				if (value) {
					toastr.warning(t('warningIgnitionWire'), { position: 'top-center' });
				}
				break;
		}
		setState({ ...state, data: { ...state.data, [field]: value } })
	}

	// const onMetricInputChange = (e) => {
	// 	const { target } = e;
	// 	let { name, value } = target;

	// 	value = state.data.adas_units === 'imperial' ? value * 2.54 : value;

	// 	setState({
	// 		...state,
	// 		data: { ...state.data, [name]: value },
	// 	})
	// }

	// const numberFormat = (argName, argValue = null) => {
	// 	let value = (argValue || state.data[argName]) * 1

	// 	if (state.data.adas_units === 'imperial') {
	// 		value = value / 2.54
	// 	} // ? (data.adas_vehicle_width / 2.54).toFixed(0) : data.adas_vehicle_width.toFixed(0)

	// 	return value ? value.toFixed(0) : value
	// }

	const onChangeGroups = (event) => {
		setState({
			...state,
			data: { ...state.data, groups: [event.target.value] }
		})
	}

	const hideModalApplyProfile = () => {
		setShowModalApplyProfile(false)
		checkingDevicesOfflineDisabled()
	}

	// const hideConfigModal = () => {
	// 	setState({ ...state, showConfigModal: false })
	// }

	// const hideAddInstallReportModal = () => {
	// 	setState({ ...state, showAddInstallReportModal: false })
	// }

	// const hideModalInstallReport = () => {
	// 	setState({ ...state, showModalInstallReport: false })
	// }

	// const showInstallReport = () => {
	// 	setState({ ...state, showModalInstallReport: true })
	// }

	const downloadConfig = () => {
		toggleLoader(true);
		const { device_id } = state.data;
		getConfigFile(userRole, device_id)
			.then((res, err) => {
				console.log('!downloadConfig getFirmware res', res.data);
				toggleLoader(false);
				let file = res.data;
				let blob = new Blob([file], { type: 'text/plain;charset=utf-8' });
				FileSaver.saveAs(blob, 'config.txt');
				toastr.success('Success', t('fileDownloaded'));
			})
			.catch((error) => {
				toggleLoader(false);
				console.log(error);
				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			});
	}

	const handleRebootDeviceClick = () => {
		toggleLoader(true);
		apiCallGet('/device/{device_id}/restart', { device_id: state.data.device_id })
			.then((res, err) => {
				toggleLoader(false);
				console.log('!onRebootDeviceClick res, err: ', res, err)

				setState({ ...state, data: { ...state.data, ads_online: false } })
				toastr.success('Success', t('rebootSent'))
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('!onRebootDeviceClick error:', error.response, error)
				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			})
	}

	const saveAdasCalibrationSettings = (argDevice) => {
		setState({ ...state, data: { ...state.data, ...argDevice } })
	}

	// FWSD-6482, If a device cannot be reached to complete the request (Offline/Disabled), display a modal informing the user the request cannot be completed that this time.
	const checkingDevicesOfflineDisabled = () => {
		const { data } = state
		const { status, vehicle_name, device_id } = data

		if (['disabled', 'offline'].includes(status)) {
			setDevicesOfflineDisabled([vehicle_name || device_id])
		}
	}

	const { deviceId, data } = state;
	if (!data || !data.device_id) {
		return (
			<div className="edit-vehicle">
				<GreyHeader title={t('titleEditVehicle')} hideSubtitle />
				{t('noDeviceID')}
			</div>
		)
	}

	const { initialData, errMessage, showModalProvisionDevice, showConfigModal, showDeleteModal, iconDropdownOpen, showModalInstallReport, showAddInstallReportModal, showModalDeviceArchiveHistory, provisionType, companyData } = state
	const { errvehicle_name, errgroups, errdata_limit } = errMessage;
	// const firmware = location.state.firmware;

	const readOnly = (['user', 'installer', 'partner_view', 'storage_user', 'sales_demo'].indexOf(userRole) > -1
		|| (['custom_user', 'custom_partner'].includes(userRole) && !_.find(user.permissions, { perm_category_id: 5, a_edit: true })));
	const editVehicleNameAccess = ['system_admin', 'customer_service', 'fleet_manager', 'fleet_maintainer', 'partner'].includes(userRole)
		|| isCustomUserPermissions(userRole, userPermissions, 'vehicle_edit')
	const canViewProfile = ['system_admin', 'customer_service', 'fleet_manager', 'fleet_maintainer', 'partner', 'storage_manager'].includes(userRole)
		|| (['custom_user', 'custom_partner'].includes(userRole) && !_.find(user.permissions, { perm_category_id: 3, a_view: true }));
	// const hasPartnerAccess = [2171, 537].includes(user.company_id) && userRole === 'partner';
	// FWSD-5194, mismatch of device config.txt and database values
	const hasDiffPendingCardreader = data.pending_config && _.has(data.pending_config, 'cardreader') && data.pending_config.cardreader !== data.cardreader;
	const hasDiffPendingCanbus = data.pending_config && _.has(data.pending_config, 'canbus') && data.pending_config.canbus !== data.canbus;
	// const hastExternalCredentials = geotabCredentials?.database || webfleetCredentials?.account;
	const hastExternalCredentials = companyData.external_srv_type || companyData.geotab_database || state.data.geotab.serial_number || state.data.external_srv.type  // externalCredentials?.type
	const isCompanyLiveStreamActive = company.company_data && company.company_data.live_active;
	const isCameraExceededDataThreshold = initialData.exceeded_livestream_limit;
	const hasDiffPendingCanLogUpload = data.pending_config && _.has(data.pending_config, 'can_log_upload') && (data.pending_config.can_log_upload) !== (data.can_log_upload);
	const hasDiffPendingIgnitionSwitchOnly = data.pending_config && _.has(data.pending_config, 'ignition_switch_only') && (data.pending_config.ignition_switch_only !== initialData.ignition_switch_only);
	const hasStorageData = data.onboard_capacity || data.sdcard_capacity;

	const totalHours = () => {
		let h = 0;

		const calcH = (h, t) =>
		(t ? h * ((data.onboard_capacity - data.storage_wear.onboard_free_space) / data.onboard_capacity) :
			h * ((data.sdcard_capacity - data.storage_wear.sdcard_free_space) / data.sdcard_capacity));

		const calcHours = (e, t) => {
			if (isDV6 || isDV7) {
				switch (e) {
					case 131072:
						h += 70
						break
					case 262144:
						h += 143
						break
					case 524288:
						h += 288
						break
					case 1048576:
						h += 576
						break
					default:
						h += (e / 1024) * 0.55;
						break
				}
				h = calcH(h, t);
			}

			if (isDV4) {
				switch (e, t) {
					case 65536:
						h += 89
						break
					case 131072:
						h += 179
						break
					case 262144:
						h += 358
						break
					case 524288:
						h += 715
						break
					default:
						h += (e / 1024) * 1.4;
						break
				}
				h = calcH(h, t);
			}
		}

		if (data.onboard_capacity) calcHours(data.onboard_capacity, true);
		if (data.sdcard_capacity) calcHours(data.sdcard_capacity, false);

		return Math.trunc(h)
	};

	const onboard_capacity = Math.trunc((data.onboard_capacity) / 1024);
	const sdcard_capacity = Math.trunc((data.sdcard_capacity) / 1024);

	const displayDeviceProfileName = () => {
		const hasPendingProfile = canViewProfile && data.config_checksum === 1 && data.pending_company_profile && data.pending_company_profile.toLowerCase() !== 'manual'
		const hasUploadedProfile = canViewProfile && data.uploaded_company_profile && data.uploaded_company_profile.toLowerCase() !== 'manual'

		if (hasPendingProfile) {
			return (
				<span style={{ fontSize: '18px', display: 'inline-block', verticalAlign: 'bottom' }}>
					<span style={{ marginRight: '5px' }}>
						{t('pendingUpdate')}
					</span>
					<CustomButton
						name="uploaded_company_profile"
						variant="link"
						onClick={() => browserHistory.push({
							pathname: '/managevehicles',
							state: { profile_name: data.pending_company_profile, tabKey: 2, device_id: deviceId }
						})}
					>
						{data.pending_company_profile}
					</CustomButton>
				</span>
			)
		}

		if (hasUploadedProfile) {
			return (
				<CustomButton
					name="uploaded_company_profile"
					variant="link"
					onClick={() => browserHistory.push({
						pathname: '/managevehicles',
						state: { profile_name: data.uploaded_company_profile, tabKey: 2, device_id: deviceId }
					})}
				>
					{data.uploaded_company_profile}
				</CustomButton>
			)
		}

		return <label className="control-label">{data.uploaded_company_profile || data.pending_company_profile || t('Manual')}</label>
	}

	return (
		<div className="edit-vehicle">
			<GreyHeader
				title={data.vehicle_name || data.device_id}
				renderSubtitle={
					<nav className="page-subtitle">
						<CustomButton
							variant='subtitle'
							active={tabKey === 1}
							onClick={() => setTabKey(1)}
							ga_params={{ category: userRole, action: 'Change Edit Vehicles Tab', label: 'Asset Settings' }}
						>
							{t('assetSettings')}
						</CustomButton>
					</nav>
				}
			/>

			{tabKey === 1 && (
				<>
					<div className="page-subheader">
						<div className={classnames('subheader-section edit-asset', { 'has-error': errvehicle_name })}>
							<h3 className="category-title">{t('primaryDeviceInformation')}</h3>
							<CustomButton
								variant="link"
								onClick={() => setState({ ...state, showModalDeviceArchiveHistory: true })}
							>
								{t('btnViewHistory')}
							</CustomButton>
						</div>
						<div className="subheader-section">
							{!readOnly && <CustomButton variant="secondary" onClick={() => saveVehicle(false)}>{t('btnSave')}</CustomButton>}
							<CustomButton variant="secondary-outline" onClick={goBack}>{t('btnBack')}</CustomButton>
							{isInternalUser(userRole) && (
								<CustomButton variant="delete" onClick={() => setState({ ...state, showDeleteModal: true })}>{t('btnDelete')}</CustomButton>
							)}
						</div>
					</div>

					<main className="edit-asset-block main-content-block">
						<Row>
							<Col xs={12} lg={6}>
								<p>
									{t('primaryDeviceNote1')}<br />
									{t('primaryDeviceNote2')}
								</p>
								<div className="card-wrapper">
									<div className="card-grid">
										{!!data.device_id && (
											<>
												<div className="rowKey">{t('deviceType')}</div>
												<div className="rowValue flex">{isDV6 ? 'DV6' : isDV7 ? 'DV7' : 'DV4'}
													{data.migration &&
														<CustomOverlayTrigger
															{...{ type: "warn", title: t('migrationInProgress'), body: t('overlayTriggerWarnBody') }}
															placement="top"
															prefix="ackn"
															trigger="click"
														>
															<CustomButton variant="link">
																<RiAlertLine className="alert-error" />
																{t('migrationInProgress')}
															</CustomButton>
														</CustomOverlayTrigger>
													}
												</div>
											</>
										)}
										{!!data.serial_number && (
											<>
												<div className="rowKey">{!isDV4 ? t('IMEI') : t('serialNumber')}</div>
												<div className="rowValue">{data.serial_number}</div>
											</>
										)}
										{!!data.modem && data.modem.simcard_iccid && (
											<>
												<div className="rowKey">{t('ICCID')}</div>
												<div className="rowValue">{data.modem.simcard_iccid}</div>
											</>
										)}
										<div className="rowKey">{t('labelFirstConnection')}</div>
										<div
											className="rowValue">{data.activated_timestamp ? formatTimestamp(data.activated_timestamp, true) : t('notAvailable')}</div>
										<div className="rowKey">{t('labelStatus')}</div>
										<div className="rowValue">
											<span className="fleet-activity-status">
												{formatOnlineStatusLocal(null, data)}
											</span>
										</div>
										<div className="rowKey">{t('labelDeviceID')}</div>
										<div className="rowValue">{data.device_id}</div>
										{isInternalUser(userRole) && (
											<>
												<div className="rowKey">{t('labelFirmware')}</div>
												<div className="rowValue">{data.firmware || t('notAvailable')}</div>
											</>
										)}
										{DV7access && hasStorageData && (
											<>
												<div className="rowKey">{t('labelStorage')}
													<IconTooltip
														description={t('storageDescription')}
														id="driver-id-tooltip"
													/>
												</div>
												<div className="rowValue rowStorage">
													<span className="control-label">{t('labelTotal')} {totalHours()}h</span>
													<div className="barContainer">
														<div className="barItem">
															{!!data.onboard_capacity && <div className="barLine onboard" style={{ flexBasis: `${onboard_capacity * 0.5}px` }} />}
															{!!data.sdcard_capacity && <div className="barLine sdcard" style={{ flexBasis: `${sdcard_capacity * 0.5}px` }} />}
														</div>
														<div className="descriptionItem">
															{!!data.onboard_capacity && <span className="control-label">{t('labelOnboard')} {onboard_capacity}GB</span>}
															{!!data.sdcard_capacity && <span className="control-label">{t('labelSD')} {sdcard_capacity}GB</span>}
														</div>
													</div>
												</div>
											</>
										)}
										<div className="rowKey">{t('profile')}</div>
										<div className="rowValue">
											{displayDeviceProfileName()}
											{canViewProfile &&
												<div>
													<CustomButton
														variant="primary-outline"
														onClick={() => setShowModalApplyProfile(true)}
														disabled={!data.activated_timestamp}
													>
														{t('btnUpdateProfile')}
													</CustomButton>
												</div>
											}
										</div>
										{['fleet_manager', 'partner', 'system_admin', 'customer_service'].includes(userRole) && !isDV4 && (
											<>
												<div
													className={`rowKey control-label ${hasDiffPendingCanbus ? 'has-pending-config' : ''}`}>
													{t('labelCANBus')}
													{hasDiffPendingCanbus &&
														<IconTooltip
															description={` ${t('CANBusDescription')} "${constants.canbusItems.find(({ value }) => value === data.pending_config.canbus).name || t('Different')}" `}
															id="canbus-tooltip"
														/>
													}
													<div>
														<a href="https://support.roscovision.com/knowledge/how-to-use-fleet-profiles"
															className="btn btn-link" target="_blank">
															{t('linkLearnMore')}
														</a>
													</div>
												</div>
												<div className="rowValue">
													<select
														placeholder="select"
														className="rosco-select block"
														name="canbus"
														id="canbus"
														value={state.data.canbus || "0"}
														onChange={onInputChange}
													>
														{
															constants.canbusItems.map(({ value, name }) => <option
																key={value} value={value}>{name}</option>)
														}
													</select>
												</div>
											</>
										)}
										{(company.driver_recognition !== 'manual' && ['system_admin', 'customer_service', 'fleet_manager', 'group_manager', 'partner'].indexOf(userRole) > -1) && (
											<>
												<div className="rowKey">
													{t('labelDriverID')}
													<IconTooltip
														description={`${t('driverIDDescription1')}
														${hasDiffPendingCardreader ? t('driverIDDescription2') + _.upperFirst(data.pending_config.cardreader) : ''} `}
														id="driver-id-tooltip"
													/>
												</div>
												<div className={classnames('rowValue', { 'has-error': errgroups })}>
													<span
														className="toggle-left-title device-label">{data.cardreader ? t('Enabled') : t('Disabled')}</span>
													<Toggle
														name="cardreader"
														icons={false}
														checked={data.cardreader || false}
														onChange={onInputChange}
													/>
												</div>
											</>
										)}
									</div>
								</div>
								{!isDV4 && (
									<div className="card-wrapper">
										<AdasCalibrationSettings
											device={data}
											onSave={saveAdasCalibrationSettings}
										/>
									</div>
								)}
								<div className="info-category">
									{!isDV4 && ['system_admin', 'customer_service', 'partner', 'fleet_manager'].includes(userRole) && (
										<div className="settingsCard">
											<div className="cardHeader">
												<div className="ml-5">
													{t('cardHeaderIgnitionSwitchOnly')}
													{hasDiffPendingIgnitionSwitchOnly &&
														<IconTooltip
															description={t('ignitionSwitchOnlyDescription', { value: `"${data.pending_config.ignition_switch_only || false}"` })}
															id="ignition-switch-tooltip"
														/>
													}
												</div>
												<Toggle
													name="ignition_switch_only"
													checked={data.ignition_switch_only || false}
													icons={false}
													onChange={onInputChange}
												/>
											</div>
											<div className="cardBody">
												<p className="cardNoteIgnitionSwitchOnly">{t('cardNoteIgnitionSwitchOnly')}</p>
												<ul>
													<li dangerouslySetInnerHTML={{ __html: t('cardBodyIgnitionSwitchOnlyItem1') }} />
													<li dangerouslySetInnerHTML={{ __html: t('cardBodyIgnitionSwitchOnlyItem2') }} />
												</ul>
											</div>
										</div>
									)}
								</div>
							</Col>
							<Col xs={12} lg={6}>
								<h3 className="category-title">{t('assetInformation')}</h3>
								<div className="card-grid">
									<div className="rowKey">{t('labelName')}</div>
									<div className="rowValue">
										<input
											readOnly={!editVehicleNameAccess}
											type="text"
											name="vehicle_name"
											className="vehicle-search"
											onChange={onInputChange}
											value={data.vehicle_name}
										/>
										{errvehicle_name && <span className="help-block">{errvehicle_name}</span>}
									</div>
									<div className="rowKey">{t('labelVIN')}</div>
									<div className="rowValue">{data.vin_number || t('notAvailable')}</div>
									<div className="rowKey">{t('labelLicensePlate')}</div>
									<div className="rowValue">{data.tag_plate || t('notAvailable')}</div>
									{isInternalUser(userRole) && (
										<>
											<div className="rowKey">{t('labelFleetToken')}</div>
											<div className="rowValue">{company.token || t('notAvailable')}</div>
										</>
									)}
									{(['storage_manager', 'storage_user'].indexOf(userRole) === -1) && (
										<>
											<div className="rowKey">{t('labelIcon')}</div>
											<div className="rowValue">
												{!readOnly ? (
													<Dropdown
														autoClose
														id="icon-dropdown"
														className="icon-dropdown"
														show={iconDropdownOpen}
														onToggle={(isOpen) => setState({
															...state,
															iconDropdownOpen: isOpen
														})}
													>
														<Dropdown.Toggle>
															<Image
																src={vehicleIcons.filter((item) => item.value === state.data.vehicle_icon)[0].src}
																style={state.data?.vehicle_icon?.includes('s_van') ? { maxHeight: '10px', marginTop: '5px' } : {}}
															/>
														</Dropdown.Toggle>
														<Dropdown.Menu>
															<div className="icon-menu">
																{vehicleIcons.map(vehicle =>
																	<div className="icon-wrapper"
																		onClick={() => changeVehicleIcon(vehicle.value)}
																		key={vehicle.name} value={vehicle.name}>
																		<Image src={vehicle.src}
																			style={vehicle.value.includes('s_van') ? { maxHeight: '10px', marginTop: '5px' } : {}} />
																	</div>
																)}
															</div>
														</Dropdown.Menu>
													</Dropdown>
												) : (
													<Image className="icon-dropdown"
														src={vehicleIcons.filter((item) => item.value === state.data.vehicle_icon)[0].src}
														style={state.data?.vehicle_icon?.includes('s_van') ? { maxHeight: '10px', marginTop: '5px' } : {}}
													/>
												)}
											</div>
										</>
									)}
									<div className="rowKey">
										{t('labelGroup')}
										<IconTooltip
											description={t('groupDescription')}
											id="group-tooltip"
										/>
									</div>
									<div className={classnames('rowValue', { 'has-error': errgroups })}>
										{(!readOnly && userRole !== 'group_manager') ? (
											<select
												placeholder="select"
												className={`rosco-select block ${readOnly && 'disabled'}`}
												name="groups"
												id="groups"
												value={data.groups[0] || ''}
												style={{ paddingTop: 0 }}
												onChange={onChangeGroups}
											>
												<option hidden value={''}>{t('selectGroup')}</option>
												{groupsList.map((group, index) =>
													<option key={group + index} value={group}>{group}</option>
												)}
											</select>
										) : (
											<input className="vehicle-search" value={data.groups[0]} readOnly />
										)}
										{errgroups && <span className="help-block">{errgroups}</span>}
									</div>
								</div>
								<div className="info-category">
									<h4 className="info-title">{t('titleAdminSettings')}</h4>
									<p>{t('textAdminSettings')}</p>
									<div className="button-wrapper" style={{ marginLeft: 0 }}>
										{isInternalUser(userRole) && (
											<>
												{hastExternalCredentials &&
													<>
														<CustomButton
															variant="primary-outline"
															// onClick={() => setState({ ...state, showModalProvisionDevice: true, provisionType: 'geotab' })}
															onClick={() => setState({
																...state,
																showModalProvisionDevice: true
															})}
														>
															{t('titlePairExternalDevice')}
														</CustomButton>
													</>
												}
												<CustomButton
													variant="primary-outline"
													onClick={() => setState({ ...state, showConfigModal: true })}>
													{t('btnRemoteManagement')}
												</CustomButton>
												<CustomButton
													variant="primary-outline"
													onClick={downloadConfig}>
													{t('btnRequestConfig')}
												</CustomButton>
												{!data.installed_id &&
													<CustomButton
														variant="primary-outline"
														onClick={() => setState({
															...state,
															showAddInstallReportModal: true
														})}>
														{t('btnAddInstallReport')}
													</CustomButton>
												}
											</>
										)}
										{data.installed_id && (
											<CustomButton
												variant="primary-outline"
												onClick={() => setState({ ...state, showModalInstallReport: true })}>
												{t('btnInstallReport')}
											</CustomButton>
										)}
										{isInternalUserWithPartner(userRole) && (
											<CustomButton variant="primary-outline"
												prefix={`${!data.ads_online && 'disabled'}`}
												disabled={!data.ads_online} onClick={handleRebootDeviceClick}>
												{t('btnRebootDevice')}
											</CustomButton>
										)}
										{isInternalUser(userRole) && data.device_type === 'dv6' &&
											<CustomButton
												variant="primary-outline"
												onClick={() => setShowModalDeviceReplace(true)}>
												{t('btnReplace')}
											</CustomButton>
										}
									</div>
									{isInternalUser(userRole) && (
										<div className="button-wrapper" style={{ marginLeft: 0 }}>
											<CameraEnableToggle
												isActive={data.active}
												onChange={onInputChange}
												addClass={!isCompanyLiveStreamActive ? 'inline' : ''}
											/>

											{isCompanyLiveStreamActive && (
												<div className="toggle-wrapper">
													<div className="device-label">
														{t('labelLiveStream')}
														<IconTooltip
															description={t('textLiveStream')}
															id="disable-vehicle-tooltip"
														/>
													</div>
													<label>
														<span
															className="toggle-left-title">{data.disable_live_stream ? t('Disabled') : t('Enabled')}</span>
														<Toggle
															name="disable_live_stream"
															icons={false}
															checked={!isCameraExceededDataThreshold && (!data.disable_live_stream || false)}
															onChange={onInputChange}
															disabled={isCameraExceededDataThreshold}
														/>
													</label>
												</div>
											)}
											<div className="toggle-wrapper">
												<div
													className={`device-label${hasDiffPendingCanLogUpload ? ' has-pending-config' : ''}`}>
													{t('labelCanLogUpload')}
													{hasDiffPendingCanLogUpload &&
														<IconTooltip
															description={`${t('descriptionPendingCanLogUpload')} = ${data.pending_config.can_log_upload || false}`}
															id="can_log_upload-tooltip"
														/>
													}
												</div>
												<label>
													<span
														className="toggle-left-title">{data.can_log_upload ? t('Enabled') : t('Disabled')}</span>
													<Toggle
														name="can_log_upload"
														icons={false}
														checked={data.can_log_upload || false}
														onChange={onInputChange}
													/>
												</label>
											</div>
										</div>
									)}
									{userRole === 'partner' && (
										<CameraEnableToggle
											isActive={data.active}
											onChange={onInputChange}
											addClass="inline"
										/>
									)}
								</div>
								{!!data.device_id &&
									<div className={`device-type ${isDV6 ? 'dv6' : isDV7 ? 'dv7' : 'dv4'}`} />
								}
							</Col>
						</Row>
					</main>

					{showModalProvisionDevice
						&& (
							<ModalProvisionDevice
								device={initialData}
								companyData={companyData}
								externalCredentials={externalCredentials}
								onHide={() => setState({ ...state, showModalProvisionDevice: false })}
								updateDeviceData={getDevice}
							/>
						)}

					{showModalApplyProfile
						&& (
							<ModalChangeConfBatch
								userRole={userRole}
								// companyData={{partner_company: location.state.company.partner, company_name: location.state.company.name}}
								companyData={{
									partner_company: state.data.partner_name,
									company_name: state.data.company_name
								}}
								selectedAssets={[initialData.device_id]}
								clearSelection={hideModalApplyProfile}
								onHide={hideModalApplyProfile}
								getCompanyDevices={getDevice}
							/>
						)}

					{showConfigModal
						&& (
							<ConfigModal
								device={initialData}
								onHide={() => setState({ ...state, showConfigModal: false })}
								user_role={userRole}
								clearSelection={checkingDevicesOfflineDisabled}
							/>
						)}

					{showDeleteModal
						&& (
							<VehicleDeleteModal
								device={data}
								userRole={userRole}
								onHide={() => setState({ ...state, showDeleteModal: false })}
							/>
						)}

					<Modal
						show={showConfirmCanbusModal}
						onHide={() => setshowConfirmCanbusModal(false)}
						dialogClassName="has-error modal-lg-size"
					>
						<Modal.Header closeButton>
							<Modal.Title className="delete-title">{t('titleAreYouSure')}</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<div className="modal-text">
								<strong className="error-message">{t('modalCaution')}</strong> {t('modalText', { none: '"none"' })}
							</div>
						</Modal.Body>
						<Modal.Footer className="default-modal-footer modal-footer">
							<CustomButton
								variant="primary-outline"
								onClick={() => setshowConfirmCanbusModal(false)}
							>
								{t('btnCancel')}
							</CustomButton>
							<CustomButton
								variant="delete"
								onClick={() => {
									saveVehicle(true);
									setshowConfirmCanbusModal(false);
								}}
							>
								{t('btnConfirm')}
							</CustomButton>
						</Modal.Footer>
					</Modal>

					{showAddInstallReportModal
						&& (
							<AddInstallReportModal
								device={initialData}
								onHide={() => setState({ ...state, showAddInstallReportModal: false })}
								user={user}
								showInstallReport={() => setState({ ...state, showModalInstallReport: false })}
							/>
						)}

					{showModalInstallReport
						&& (
							<ModalInstallReport
								device={initialData}
								onHide={() => setState({ ...state, showModalInstallReport: false })}
							/>
						)}


					{showModalDeviceReplace
						&& (
							<ModalDeviceReplace
								device={initialData}
								updateDeviceData={getDevice}
								onHide={() => setShowModalDeviceReplace(false)}
							/>
						)}

					{showModalDeviceArchiveHistory
						&& (
							<DeviceArchiveHistory
								device={initialData}
								onHide={() => setState({ ...state, showModalDeviceArchiveHistory: false })}
							/>
						)}

					{devicesOfflineDisabled.length > 0 &&
						<ModalDeviceOfflineDisabled
							devicesOfflineDisabled={devicesOfflineDisabled}
							onHide={() => setDevicesOfflineDisabled('')}
						/>
					}
				</>
			)}
		</div>
	)
}

EditAssetContainer.propTypes = {
	user: PropTypes.objectOf(PropTypes.any).isRequired,
	company: PropTypes.objectOf(PropTypes.any).isRequired
};

export default connect(
	state => ({
		user: state.user.user,
		company: state.company.company
	}),
	dispatch => ({
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		}
	})
)(EditAssetContainer);
